import React from "react";
import {
  useNotification,
  AlertMessage,
  NotificationTabs,
  SendNotificationForm,
  HistoryFilters,
  NotificationHistoryTable,
  formatDate,
} from "../../components/Notification";
import PaginationBar from "../../components/common/PaginationBar";
import { TableSkeleton } from "../../components/common/skeletons";

export default function Notification() {
  const {
    activeTab,
    setActiveTab,
    newNotification,
    setNotificationField,
    setUserType,
    searchedUser,
    setSearchedUser,
    searchingUser,
    countries,
    loading,
    loadingCountries,
    error,
    successMsg,
    notificationHistory,
    loadingHistory,
    historyError,
    currentPage,
    setCurrentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    historyFilters,
    handleSearchUser,
    handleCreateNotification,
    handleFilterChange,
    getActiveFiltersCount,
    getFilterLabel,
    removeFilter,
    clearAllFilters,
  } = useNotification();

  const activeFiltersCount = getActiveFiltersCount();

  return (
    <div className="p-3 sm:p-4 w-full min-w-0 overflow-x-hidden">
      <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
        <h2 className="text-lg md:text-2xl font-bold text-gray-800">
          Notifications
        </h2>
        {successMsg && activeTab === "send" && (
          <div className="text-green-700 bg-green-100 px-4 py-2 rounded-lg text-sm font-medium border border-green-200 shrink-0">
            {successMsg}
          </div>
        )}
      </header>

      <NotificationTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        activeFiltersCount={activeFiltersCount}
      />

      {activeTab === "send" && (
        <>
          {error && (
            <AlertMessage variant="error" message={error} title="Error:" />
          )}
          {loading && (
            <AlertMessage variant="loading" message="Processing..." />
          )}

          <SendNotificationForm
            newNotification={newNotification}
            setNotificationField={setNotificationField}
            setUserType={setUserType}
            countries={countries}
            loadingCountries={loadingCountries}
            searchedUser={searchedUser}
            setSearchedUser={setSearchedUser}
            searchingUser={searchingUser}
            handleSearchUser={handleSearchUser}
            handleSubmit={handleCreateNotification}
            loading={loading}
          />
        </>
      )}

      {activeTab === "history" && (
        <div className="bg-white rounded-xl shadow-xl p-4 sm:p-6 min-w-0 overflow-x-hidden">
          <HistoryFilters
            filters={historyFilters}
            onFilterChange={handleFilterChange}
            getFilterLabel={getFilterLabel}
            onRemoveFilter={removeFilter}
            onClearAll={clearAllFilters}
            activeCount={activeFiltersCount}
          />

          {historyError && (
            <AlertMessage variant="error" message={historyError} />
          )}

          {loadingHistory && <TableSkeleton rows={8} cols={6} />}

          {!loadingHistory && (
            <>
              <NotificationHistoryTable
                notifications={notificationHistory}
                formatDate={formatDate}
                emptyFiltersCount={activeFiltersCount}
              />
              <PaginationBar
                page={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                pageSize={itemsPerPage}
                label="notifications"
                onPageChange={setCurrentPage}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
}
